import styles from './elsnostresjocs.module.scss';
import Fila from 'components/corporatiu/Fila';
import Icona from 'components/corporatiu/Icona';

const ElsnostresJocs = () => {
    return (
        <div className={styles.contentModul}>
            <Fila columnes='12' tipus='fixed'>
                <div className={styles.innerWrapper}>
                    <h2 className={styles.titol}>Els nostres videojocs</h2>
                    <p>
                        Els videojocs de 3Cat són jocs en català per a tots els públics i per a tots els sistemes: consoles
                        (PlayStation, Xbox i Nintendo Switch), ordinador (Steam), mòbils i tauletes (iOS i Android) i navegador
                        web. Estan fets per empreses del sector català del videojoc, amb referències a la cultura i la geografia
                        catalanes, i segueixen els valors del nostre llibre d&apos;estil. Hi pots jugar gratis.
                    </p>
                    <div className={styles.info}>
                        <div>
                            <Icona icona='jocs' isBlanc={true} className={styles.icona} />
                            <p>
                                <strong>A les principals plataformes de joc</strong>
                            </p>
                            <p>Disponibles a Playstation, Switch, Xbox, Steam, iOS, Android i web</p>
                        </div>
                        <div>
                            <Icona icona='catalunya' isBlanc={true} className={styles.icona} />
                            <p>
                                <strong>Amb Catalunya com a referent</strong>
                            </p>
                            <p>En català i amb referències a cultura i geografia catalanes</p>
                        </div>
                        <div>
                            <Icona icona='estrella' isBlanc={true} className={styles.icona} />
                            <p>
                                <strong>Potenciant el sector</strong>
                            </p>
                            <p>Fets per empreses del sector català dels videojocs</p>
                        </div>
                    </div>
                </div>
            </Fila>
        </div>
    );
};

export default ElsnostresJocs;
